import Cookies from 'js-cookie'
const TokenKey = 'Authorization'
const RefreshToken = 'RefreshToken'
/**
 * 获取TOKEN
 * @return {[type]} [description]
 */
export function getToken() {
  return Cookies.get(TokenKey)
}
/**
 * 设置TOKEN
 * @param {[type]} token [description]
 */
export function setToken(token) {
  return Cookies.set(TokenKey, token, {
    expires: 2
  })
}
//refreshToken
export function getRefreshToken() {
  return Cookies.get(RefreshToken)
}
/**
 * 设置TOKEN
 * @param {[type]} token [description]
 */
export function setRefreshToken(token) {
  return Cookies.set(RefreshToken, token, {
    expires: 8
  })
}
/**
 * 刪除TOKEN
 * @return {[type]} [description]
 */
export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function removeRefreshtoken() {
  return Cookies.remove(RefreshToken)
}


/**
 * 获取showList
 * @return {[type]} [description]
 */
export function getShowList() {
  return Cookies.get('ShowList')
}
/**
 * showList
 * @param {[type]} showList [description]
 */
export function setShowList(showList) {
  return Cookies.set('ShowList', showList)
}
/**
 * 刪除TOKEN
 * @return {[type]} [description]
 */
export function removeShowList() {
  return Cookies.remove('ShowList')
}


// 获取本地记录语言
export function getLang() {
  return localStorage.getItem('lang')
}

// 本地设置语言
export function setLang(lang) {
  return localStorage.setItem('lang', lang)
}

//设置项目
export function setObject(params) {
  return localStorage.setItem('project', params)
}
//设置项目
export function getProject() {
  return localStorage.getItem('project')
}
/**
 * 保存账号密码
 * @param {[type]} psd [description]
 */
export function setPsd(psd, type) {
  return Cookies.set('psd' + type, psd, {
    expires: 15
  }) //15天
}
/**
 * 获取账号密码
 * @param {[type]} psd [description]
 */
export function getPsd(type) {
  return Cookies.get('psd' + type);
}
/**
 * 刪除账号密码
 * @param {[type]} psd [description]
 */
export function removePsd(type) {
  return Cookies.remove('psd' + type);
}

/**
 * 年月日时分秒
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
export function formatDateTime(value) {
  let date = new Date(value * 1000);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}
export function formatDateTimeMS(value) {
  let date = new Date(value * 1000);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  let s2 = date.getMilliseconds();
  s2 = s2 < 10 ? ('0' + s2) : s2;
  return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s + "." + s2;
}
/**
 * 年月日
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
export function formatDate(value) {
  let date = new Date(value * 1000);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + MM + '-' + d;
}

export function timestamp(time) {
  if ((time + "").length == 10) {
    time = time * 1000;
  }
  var date = new Date(time);
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10 ?
      "0" + (date.getMonth() + 1) :
      date.getMonth() + 1) + "-";
  var D =
    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  var s =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  var strDate = Y + M + D + h + m + s;
  return strDate;
}

// 累计多少天
export function formatCurrentDate(value) {
  var timestamp = Date.parse(new Date());

  var date = Math.floor((timestamp - value * 1000) / 1000 / 60 / 60 / 24)

  return date
}
// 累计使用百分比
export function formatCurrentPer(startDate, life) {
  if (startDate == null || life == null) return 0;
  var timestamp = Date.parse(new Date());
  var usage = timestamp * 1 - startDate * 1;
  // var p=usage*100/(life*1)
  var p = Math.floor((usage * 10000) / (life * 1)) / 100;
  // console.log(p + "%");
  return p;
}
// 累计使用百分比
export function formatFilterPer(usage, life) {
  if (usage == null || life == null) return 0;
  if (usage == 0 || life == 0) return 0;
  var p = Math.floor((usage * 10000) / (life * 1)) / 100;
  // console.log(p + "%");
  return p;
}
/**
 * 深拷贝
 * @param  {[type]} obj [description]
 * @return {[type]}     [description]
 */
export const clone = (obj) => {
  var o;
  // 如果  他是对象object的话  , 因为null,object,array  也是'object';
  if (typeof obj === 'object') {

    // 如果  他是空的话
    if (obj === null) {
      o = null;
    } else {

      // 如果  他是数组arr的话
      if (obj instanceof Array) {
        o = [];
        for (var i = 0, len = obj.length; i < len; i++) {
          o.push(clone(obj[i]));
        }
      } else { // 如果  他是对象object的话
        o = {};
        for (var j in obj) {
          o[j] = clone(obj[j]);
        }
      }
    }
  } else {
    o = obj;
  }
  return o;
};